import { EventEmitter, Injectable, OnDestroy, Output } from "@angular/core";
import { SelfSchedulingDataService } from "./self.scheduling.data.service";
import { IReservation, ISearchResult, ReservationResult } from "../interfaces/Iself.scheduling";
import { SystemConfigurationValues } from "../../../common/configuration/services/system.configuration.manager";
import { v4 as uuid } from 'uuid';
import { SelfSchedulingProxy } from "./self.scheduling.proxy";
import { takeUntilDestroy } from "take-until-destroy";
import { LogManager } from "src/common/log/log.manager";
import { LogCat } from "src/common/log/log.categories";
import { SelfSchedulingCommonService } from "./self.scheduling.common.service";

@Injectable({ providedIn: "root" })
export class SelfSchedulingReservationService implements OnDestroy {
	public readonly sessionID: string;
	public reservationIntervalId;
	private tickCount = 0;

	@Output() reservationFailed = new EventEmitter(); // TODO: This should be a subject, not an event emitter and definitely not an output

	constructor(public selfSchedulingDataService: SelfSchedulingDataService, public cfg: SystemConfigurationValues,
		public selfSchedulingProxy: SelfSchedulingProxy, private commonService: SelfSchedulingCommonService) {
		this.sessionID = uuid();
	}

	public reserveTimeslots(suggestion: ISearchResult[]) {
		if (!this.cfg.TimeslotReservationEnabled) { return; }

		// clear existing reservation
		this.releaseReservationCountdown();

		// create a new reservation object
		let ourReservation: IReservation;
		ourReservation = {
			minutesUntilExpiration: 0.5,
			timeslots: null,
			sessionId: this.sessionID
		};

		ourReservation.timeslots = suggestion.map((suggestionItem) => {
			return {
				spsId: suggestionItem.SPS_ID,
				spsCodeKey: suggestionItem.SPS_Code_Key,
				modality: suggestionItem.modality,
				startTime: suggestionItem.startTime,
				duration: suggestionItem.duration,
				personKeys: suggestionItem.resourceSelection.map(x => x.personKey)
			};
		});

		this.selfSchedulingProxy.reserveTimeslots(ourReservation).pipe(takeUntilDestroy(this))
			.subscribe((result: ReservationResult) => {
				if (result && result === ReservationResult.ReservationObtained) {
					// Start counting down to the reservation expiry date
					this.selfSchedulingDataService.reservation = ourReservation;
					// this.changeDetector.markForCheck();
					this.startNewReservationCountdown();
				} else {
					// failed to secure the reservation
					this.releaseReservation();
					this.reservationFailed.emit(result);
				}
			}, (error) => {
				LogManager.debug(LogCat.SelfScheduling.General, "Unknown error", error);

				this.releaseReservation();
				this.reservationFailed.emit(ReservationResult.ReservationFailed);
			});
	}

	private startNewReservationCountdown() {
		// start a new countdown timer, store interval id
		this.reservationIntervalId = setInterval(() => {
			if (this.tickCount >= 25) { //renew reservation every 25sec
				this.tickCount = 0;

				// renew the reservation with this new expiry date
				this.selfSchedulingProxy.renewReservation({ sessionId: this.sessionID, minutesUntilExpiration: 0.5 }).pipe(takeUntilDestroy(this))
					.subscribe((result) => {
						
					}, (error) => {
						LogManager.debug(LogCat.SelfScheduling.General, "Unknown error", error);
						this.commonService.showErrorNotification("UnknownError");
					})
			}

			this.tickCount++;
		}, 1000);
	}

	public releaseReservation() {
		if (!this.cfg.TimeslotReservationEnabled) { return; }

		if (this.selfSchedulingDataService.reservation) {
			this.releaseReservationCountdown();
			this.selfSchedulingDataService.reservation = null;
			this.selfSchedulingProxy.deleteReservations(this.sessionID).pipe(takeUntilDestroy(this))
				.subscribe((result) => { if (result) { } });
		}
	}

	private releaseReservationCountdown() {
		if (this.reservationIntervalId) {
			clearInterval(this.reservationIntervalId);
			this.tickCount = 0;
			this.reservationIntervalId = null;
		}
	}

	ngOnDestroy(): void {
	}
}
